import { StateFile } from "src/app/enum/state-file.enum";

export class FileState {
    file: File;
    state: StateFile;
}
